import React from 'react';
import { motion } from 'framer-motion';
import { trackPixelEvent } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://ingles-batch.impultienda.ar/o/bach-flower-consultation-guide';
export const PRODUCT_NAME = 'KIT COMPLETO FIORI DI BACH™';
export const PRICE = '20 €';
export const PRICE_SHORT = '20 €';
export const PRICE_VALUE = 20;
export const CURRENCY = 'EUR';
export const PRODUCT_SPEC = '2 volumi + 5 bonus + Mappa Rapida dei 38 Fiori';
export const SUPPORT_EMAIL = 'soportelumenakasha@gmail.com';
export const INSTAGRAM_HANDLE = '@lumen.akasha';
export const INSTAGRAM_LINK = 'https://instagram.com/lumen.akasha';

/** Meta Pixel event fired when going to checkout. */
export function trackCheckoutClick(): void {
  trackPixelEvent('InitiateCheckout', {
    content_name: PRODUCT_NAME,
    content_type: 'product',
    value: PRICE_VALUE,
    currency: CURRENCY
  });
}
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className={`relative mx-auto w-full max-w-7xl scroll-mt-16 px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-338" data-mp="39hn2vy0ww618">
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'green' | 'gold';
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'green'
}: CTAButtonProps) {
  const colors = variant === 'gold' ? 'bg-amber-400 text-emerald-950 hover:bg-amber-300' : 'bg-emerald-800 text-white hover:bg-emerald-900';
  return <motion.a href={href} onClick={() => {
    if (href === CHECKOUT_URL) trackCheckoutClick();
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-lg px-8 py-4 text-lg font-semibold shadow-sm transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 ${colors} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-339" data-mp="22v140z9o1o98">
      {children}
    </motion.a>;
}